import styled from 'styled-components'

export const FilterModal = styled.div`
  display: flex;
  position: absolute;
  flex-direction: column;
  z-index: 9999999999;
  align-items: end;
  height: 100vh;
  width: 500px;
  top: 0;
  left: 0;
  border-radius: 0 10px 10px 0;
  animation: showModal 400ms;

  @media (max-width: 600px) {
    width: 100%;

    height: 100%;
  }

  .header {
    height: 50px;
    width: 100%;
    color: #ffffff;
    background-color: #002b80;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Montserrat', sans-serif;
    text-transform: uppercase;
    font-size: 12px;
  }
  .body {
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: rgb(255, 255, 255);
    padding: 20px;
    width: 100%;
    height: 100%;
    box-shadow: 0px 2px 5px 1px rgba(0, 0, 0, 0.3);

    select {
      height: 40px;
      border: none;
      border-radius: 27px;
      width: 100%;
      padding: 0 10px;
      box-shadow: 0px 2px 20px 1px rgba(0, 0, 0, 0.2);
      cursor: pointer;
      padding: 0 20px;
      animation: showModal 400ms;

      &:focus {
        outline: none;
      }
    }

    .button {
      display: flex;
      width: 100%;
      justify-content: end;
      gap: 10px;
      font-family: 'Montserrat', sans-serif;
    }

    .cancel {
      background-color: #990000;
      animation: showModal 400ms;
      height: 40px;
    }

    .ok {
      transition: all ease-in-out 400ms;
      animation: showModal 400ms;

      background-color: #274e13;
      &:disabled {
        background-color: #7e7e7e93;
        transition: all ease-in-out 1s;
      }
    }

    .buttons {
      background-color: #00205b;
    }

    .react-calendar {
      width: 350px;
      position: absolute;
      right: 0;
      top: 100px;
      padding: 10px 20px;
      max-width: 100%;
      background: white;
      z-index: 200000000000000000;
      border: none;
      border-radius: 10px;
      font-family: 'Montserrat', Arial, Helvetica, sans-serif;
      line-height: 1.125em;
    }
    .react-calendar--doubleView {
      width: 700px;
    }
    .react-calendar--doubleView .react-calendar__viewContainer {
      display: flex;
      margin: -0.5em;
    }
    .react-calendar--doubleView .react-calendar__viewContainer > * {
      width: 50%;
      margin: 0.5em;
    }
    .react-calendar,
    .react-calendar *,
    .react-calendar *:before,
    .react-calendar *:after {
      -moz-box-sizing: border-box;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .react-calendar button {
      margin: 0;
      border: 0;
      outline: none;
    }
    .react-calendar button:enabled:hover {
      cursor: pointer;
    }
    .react-calendar__navigation {
      height: 44px;
      margin-bottom: 1em;
    }
    .react-calendar__navigation button {
      min-width: 44px;
      background: none;
    }
    .react-calendar__navigation button:enabled:hover,
    .react-calendar__navigation button:enabled:focus {
      background-color: #e6e6e6;
    }
    .react-calendar__navigation button[disabled] {
      background-color: #f0f0f0;
    }
    .react-calendar__month-view__weekdays {
      text-align: center;
      text-transform: capitalize;
      font-weight: bold;
      font-size: 0.75em;
    }

    .react-calendar__month-view__weekdays__weekday {
      padding: 0.2em;
    }
    .react-calendar__month-view__weekNumbers {
      font-weight: bold;
    }
    .react-calendar__month-view__weekNumbers .react-calendar__tile {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.75em;
      padding: calc(0.75em / 0.75) calc(0.5em / 0.75);
    }
    .react-calendar__month-view__days__day--weekend {
      color: #d10000;
    }
    .react-calendar__month-view__days__day--neighboringMonth {
      color: #757575;
    }
    .react-calendar__year-view .react-calendar__tile,
    .react-calendar__decade-view .react-calendar__tile,
    .react-calendar__century-view .react-calendar__tile {
      padding: 2em 0.5em;
    }
    .react-calendar__tile {
      max-width: 100%;
      text-align: center;
      padding: 0;
      background: none;
      width: 10px;
      height: 50px;
    }
    .react-calendar__tile:disabled {
      background-color: #f0f0f0;
    }
    .react-calendar__tile:enabled:hover,
    .react-calendar__tile:enabled:focus {
      background-color: #002b80;
      color: #ffffff;
      border-radius: 500px;
    }
    .react-calendar__tile--now {
      background: #100797ff;
      color: #ffffff;
      border-radius: 500px;
    }
    .react-calendar__tile--now:enabled:hover,
    .react-calendar__tile--now:enabled:focus {
      background: #1509b8ff;
      border-radius: 500px;
    }
    .react-calendar__tile--hasActive {
      background: #76baff;
      border-radius: 500px;
    }
    .react-calendar__tile--hasActive:enabled:hover,
    .react-calendar__tile--hasActive:enabled:focus {
      background: #a9d4ff;
      border-radius: 500px;
    }
    .react-calendar__tile--active {
      background: #006edc;
      color: white;
      border-radius: 500px;
    }
    .react-calendar__tile--active:enabled:hover,
    .react-calendar__tile--active:enabled:focus {
      background: #1087ff;
      border-radius: 500px;
    }
    .react-calendar--selectRange .react-calendar__tile--hover {
      background-color: #e6e6e6;
      border-radius: 500px;
    }
  }

  button,
  label {
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 27px;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: #ffffff;
  }

  @keyframes showModal {
    from {
      width: 0;
      overflow: hidden;
    }
  }
`
